import React from 'react';

const Paper = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7389 2.76187H8.0859C6.0059 2.75387 4.3009 4.41187 4.2519 6.49087V17.2039C4.2059 19.3169 5.8809 21.0679 7.9939 21.1149C8.0249 21.1149 8.0549 21.1159 8.0859 21.1149H16.0749C18.1689 21.0299 19.8189 19.2999 19.8039 17.2039V8.03787L14.7389 2.76187Z"
        stroke="#7A7A7A"
        strokeWidth="1.50943"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4756 2.75012V5.65912C14.4756 7.07912 15.6236 8.23012 17.0436 8.23412H19.7986"
        stroke="#7A7A7A"
        strokeWidth="1.50943"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2887 15.3586H8.88867"
        stroke="#7A7A7A"
        strokeWidth="1.50943"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2447 11.6062H8.88867"
        stroke="#7A7A7A"
        strokeWidth="1.50943"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Paper;
